import { Suspense } from 'react'
import { BrowserRouter, Route, Routes } from 'react-router'

import NotFound from '@/pages/NotFound'
import SignUpPage from '@/pages/SignUp'
import Loading from '@/ui-components/Loading'

const Router = () => {
  return (
    <BrowserRouter>
      <Suspense fallback={<Loading />}>
        <Routes>
          <Route
            path="/"
            element={<SignUpPage />}
          />

          {/* 404 Catch-all Route - Must be last */}
          <Route
            path="*"
            element={<NotFound />}
          />
        </Routes>
      </Suspense>
    </BrowserRouter>
  )
}

export default Router
